import { useQuery } from '@tanstack/react-query';
import { apiClient as api } from '@plerionhq/design-system';

export const usePlerionAISettings = () => {
  return useQuery({
    queryKey: ['usePlerionAISettings'],
    queryFn: async () => {
      const res = await api.get<{ data: { isAllowedAccess: boolean } }>(
        `/api/core/pleri/settings`,
      );
      return res.data?.data;
    },
  });
};
